import { FormattedMessage } from 'react-intl'
import {
  Section,
  SectionItem,
  SectionList,
  SectionTitle,
} from '../../shared/section'
import { translationsTimeTrackingSelection } from './translations/translations'
import { UserSettings } from './types'

export default function ProfileOverviewContent({
  data,
}: {
  data: UserSettings
}) {
  return (
    <>
      <Section>
        <SectionTitle>
          <FormattedMessage
            id="profile.overview.section.timeTracking.title"
            defaultMessage="Time Tracking"
          />
        </SectionTitle>
        <SectionList>
          <SectionItem>
            <FormattedMessage
              id="profile.overview.section.timeTracking.timeTrackingDefaultProjectCostCenterSelectionView.description"
              defaultMessage="Default view for time tracking project and cost center selection: "
            />
            <FormattedMessage
              {...translationsTimeTrackingSelection(
                data.timeTrackingDefaultProjectCostCenterSelectionView
              )}
            />
          </SectionItem>
        </SectionList>
      </Section>
      <Section>
        <SectionTitle>
          <FormattedMessage
            id="profile.overview.section.article.title"
            defaultMessage="Article"
          />
        </SectionTitle>
        <SectionList>
          <SectionItem>
            <FormattedMessage
              id="profile.overview.section.article.articleDialogDefaultSelectionView.description"
              defaultMessage="Default view for article selection in activity: "
            />
            <FormattedMessage
              {...translationsTimeTrackingSelection(
                data.articleDialogDefaultSelectionView
              )}
            />
          </SectionItem>
        </SectionList>
      </Section>
    </>
  )
}
